interface ILocaleInfo {
    id?: number;
    name: string;
    description?: string;
}

export const localizeInformation = (
    t: (name: string) => string,
    localeInfo: ILocaleInfo[],
    id: number,
) => {
    const { id: itemId, ...locale } = localeInfo.find((item) => item.id === id)!;
    
    const localizedInformation = Object.entries(locale).map(([key, value]) => ({
        [key]: t(value),
    }));

    return Object.assign({}, ...localizedInformation);
};
